var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.88 9.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#555;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    "data-name": "Layer 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NfBx9u.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.91,8l.54-.55A3.88,3.88,0,0,0,6.39,8.57a3.81,3.81,0,0,0,2.45-1A3.9,3.9,0,0,0,5.21.91,3.85,3.85,0,0,0,2.34,4.29H3.83L1.92,6.2,0,4.29H1.54A4.64,4.64,0,0,1,3.34,1a4.59,4.59,0,0,1,3-1A4.68,4.68,0,1,1,2.91,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.81,2h.78V4.74a.25.25,0,0,1-.06.16L5,6.47l0,0L4.38,6l.08-.09L5.74,4.59a.31.31,0,0,0,.07-.18V2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressNotes);
export default __webpack_public_path__ + "static/media/ProgressNotes.ff69aa4078a7afd20b91431804acf434.svg";
export { ForwardRef as ReactComponent };